import React, { useState, useEffect } from 'react'
import { getPerfis, updatePerfil, deletePerfil, criarUtilizador } from '../../lib/supabase'
import { useTenant } from '../../contexts/TenantContext'
import { useToast } from '../../contexts/ToastContext'
import Loading from '../../components/Loading'

const inputStyle = {
  width: '100%', padding: '9px 12px',
  border: '1px solid var(--cor-borda)', borderRadius: 'var(--raio)',
  fontSize: '14px', fontFamily: 'var(--font-ui)',
  background: 'var(--cor-branco)', color: 'var(--cor-texto)',
  boxSizing: 'border-box',
}

const ROLE_LABELS = { superuser: 'Super Admin', manager: 'Manager' }
const ROLE_CORES  = { superuser: '#7C3AED', manager: '#2563EB' }

const VAZIO_NOVO = { nome: '', telefone: '', email: '', password: '', role: 'manager' }

function BadgeRole({ role }) {
  return (
    <span style={{
      background: ROLE_CORES[role] + '18',
      color: ROLE_CORES[role],
      border: `1px solid ${ROLE_CORES[role]}40`,
      borderRadius: '20px', padding: '2px 10px',
      fontSize: '11px', fontWeight: '600',
    }}>
      {ROLE_LABELS[role] ?? role}
    </span>
  )
}

function FormNovoManager({ form, setForm, onSave, onCancel, guardando }) {
  return (
    <div style={{
      background: 'var(--cor-creme)', border: '1px solid var(--cor-borda)',
      borderRadius: 'var(--raio-lg)', padding: '20px', marginBottom: '12px',
    }}>
      <p style={{ fontWeight: '600', color: 'var(--cor-principal)', marginBottom: '16px' }}>Novo Manager</p>
      <form onSubmit={onSave}>
        <div className="grid-2col" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px', marginBottom: '16px' }}>
          <div style={{ gridColumn: '1 / -1' }}>
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '13px', fontWeight: '500' }}>Nome *</label>
            <input
              type="text"
              value={form.nome}
              onChange={e => setForm(p => ({ ...p, nome: e.target.value }))}
              style={inputStyle}
              required
            />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '13px', fontWeight: '500' }}>Telefone</label>
            <input
              type="tel"
              value={form.telefone}
              onChange={e => setForm(p => ({ ...p, telefone: e.target.value }))}
              style={inputStyle}
              placeholder="+351 900 000 000"
            />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '13px', fontWeight: '500' }}>Papel</label>
            <select
              value={form.role}
              onChange={e => setForm(p => ({ ...p, role: e.target.value }))}
              style={inputStyle}
            >
              <option value="manager">Manager</option>
              <option value="superuser">Super Admin</option>
            </select>
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '13px', fontWeight: '500' }}>Email *</label>
            <input
              type="email"
              value={form.email}
              onChange={e => setForm(p => ({ ...p, email: e.target.value }))}
              style={inputStyle}
              required
              autoComplete="off"
            />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '13px', fontWeight: '500' }}>Palavra-passe *</label>
            <input
              type="password"
              value={form.password}
              onChange={e => setForm(p => ({ ...p, password: e.target.value }))}
              style={inputStyle}
              required
              minLength={8}
              autoComplete="new-password"
            />
          </div>
        </div>
        <div style={{ display: 'flex', gap: '10px' }}>
          <button type="submit" className="btn-primario" disabled={guardando} style={{ opacity: guardando ? 0.6 : 1, padding: '9px 22px', fontSize: '14px' }}>
            {guardando ? 'A criar…' : 'Criar'}
          </button>
          <button type="button" onClick={onCancel} className="btn-secundario" style={{ padding: '9px 22px', fontSize: '14px' }}>
            Cancelar
          </button>
        </div>
      </form>
    </div>
  )
}

function FormEditarManager({ perfil, onSave, onCancel, guardando }) {
  const [form, setForm] = useState({
    nome: perfil.nome ?? '',
    telefone: perfil.telefone ?? '',
    role: perfil.role,
    ativo: perfil.ativo,
  })

  return (
    <div style={{
      background: 'var(--cor-creme)', border: '1px solid var(--cor-borda)',
      borderRadius: 'var(--raio-lg)', padding: '20px', marginTop: '4px',
    }}>
      <p style={{ fontWeight: '600', color: 'var(--cor-principal)', marginBottom: '16px' }}>Editar: {perfil.nome || perfil.email}</p>
      <form onSubmit={e => { e.preventDefault(); onSave(perfil.id, form) }}>
        <div className="grid-2col" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px', marginBottom: '16px' }}>
          <div style={{ gridColumn: '1 / -1' }}>
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '13px', fontWeight: '500' }}>Nome *</label>
            <input
              type="text"
              value={form.nome}
              onChange={e => setForm(p => ({ ...p, nome: e.target.value }))}
              style={inputStyle}
              required
            />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '13px', fontWeight: '500' }}>Telefone</label>
            <input
              type="tel"
              value={form.telefone}
              onChange={e => setForm(p => ({ ...p, telefone: e.target.value }))}
              style={inputStyle}
              placeholder="+351 900 000 000"
            />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '13px', fontWeight: '500' }}>Papel</label>
            <select
              value={form.role}
              onChange={e => setForm(p => ({ ...p, role: e.target.value }))}
              style={inputStyle}
            >
              <option value="manager">Manager</option>
              <option value="superuser">Super Admin</option>
            </select>
          </div>
        </div>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px', cursor: 'pointer', fontSize: '14px' }}>
          <input
            type="checkbox"
            checked={form.ativo}
            onChange={e => setForm(p => ({ ...p, ativo: e.target.checked }))}
          />
          Conta activa
        </label>
        <div style={{ display: 'flex', gap: '10px' }}>
          <button type="submit" className="btn-primario" disabled={guardando} style={{ opacity: guardando ? 0.6 : 1, padding: '9px 22px', fontSize: '14px' }}>
            {guardando ? 'A guardar…' : 'Guardar'}
          </button>
          <button type="button" onClick={onCancel} className="btn-secundario" style={{ padding: '9px 22px', fontSize: '14px' }}>
            Cancelar
          </button>
        </div>
      </form>
    </div>
  )
}

export default function Managers() {
  const { tenant } = useTenant()
  const toast = useToast()
  const [lista, setLista] = useState([])
  const [carregando, setCarregando] = useState(true)
  const [editando, setEditando] = useState(null)
  const [criando, setCriando] = useState(false)
  const [formNovo, setFormNovo] = useState(VAZIO_NOVO)
  const [guardando, setGuardando] = useState(false)
  const [sucesso, setSucesso] = useState(null)

  useEffect(() => {
    if (!tenant) return
    getPerfis(tenant.id)
      .then(data => setLista(data.filter(p => p.role !== 'funcionario')))
      .catch(e => toast.erro(e.message))
      .finally(() => setCarregando(false))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenant])

  function mostrarSucesso(msg) {
    setSucesso(msg)
    setTimeout(() => setSucesso(null), 3000)
  }

  async function criarNovo(e) {
    e.preventDefault()
    setGuardando(true)
    toast.erro(null)
    try {
      const novo = await criarUtilizador(tenant.id, {
        email: formNovo.email.trim(),
        password: formNovo.password,
        role: formNovo.role,
        nome: formNovo.nome.trim(),
        telefone: formNovo.telefone.trim() || null,
      })
      setLista(prev => [...prev, novo])
      setCriando(false)
      setFormNovo(VAZIO_NOVO)
      mostrarSucesso('Manager criado com sucesso.')
    } catch (e) {
      toast.erro(e.message)
    } finally {
      setGuardando(false)
    }
  }

  async function guardarEdicao(id, dados) {
    setGuardando(true)
    toast.erro(null)
    try {
      await updatePerfil(tenant.id, id, {
        nome: dados.nome.trim() || null,
        telefone: dados.telefone.trim() || null,
        role: dados.role,
        ativo: dados.ativo,
      })
      setLista(prev => prev.map(p => p.id === id ? { ...p, ...dados } : p))
      setEditando(null)
      mostrarSucesso('Alterações guardadas.')
    } catch (e) {
      toast.erro(e.message)
    } finally {
      setGuardando(false)
    }
  }

  async function eliminar(perfil) {
    if (!window.confirm(`Eliminar o utilizador "${perfil.email}"? Esta acção não pode ser desfeita.`)) return
    toast.erro(null)
    try {
      await deletePerfil(tenant.id, perfil.id)
      setLista(prev => prev.filter(p => p.id !== perfil.id))
      mostrarSucesso('Utilizador eliminado.')
    } catch (e) {
      toast.erro(e.message)
    }
  }

  return (
    <div style={{ maxWidth: '760px', margin: '0 auto', padding: '32px 24px 64px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '6px' }}>
        <h2 style={{ fontSize: '22px' }}>Managers</h2>
        {!criando && (
          <button onClick={() => { setCriando(true); setEditando(null); toast.erro(null) }} className="btn-primario" style={{ padding: '9px 20px', fontSize: '14px' }}>
            + Novo Manager
          </button>
        )}
      </div>
      <p style={{ color: 'var(--cor-texto-suave)', marginBottom: '28px', fontSize: '14px' }}>
        Gestão de managers e super admins do backoffice.
      </p>

      {sucesso && (
        <div style={{ background: '#F0FDF4', border: '1px solid #86EFAC', borderRadius: 'var(--raio)', padding: '12px 16px', marginBottom: '20px', color: '#16A34A', fontSize: '14px' }}>
          {sucesso}
        </div>
      )}

      {criando && (
        <FormNovoManager
          form={formNovo}
          setForm={setFormNovo}
          onSave={criarNovo}
          onCancel={() => { setCriando(false); toast.erro(null) }}
          guardando={guardando}
        />
      )}

      {carregando ? <Loading /> : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {lista.map(perfil => {
            const tituloPrincipal = perfil.nome || perfil.email || '—'
            const inicial = tituloPrincipal[0]?.toUpperCase() ?? '?'

            return (
              <div key={perfil.id}>
                <div style={{
                  background: 'var(--cor-branco)',
                  border: `1px solid ${perfil.ativo ? 'var(--cor-borda)' : '#E5E7EB'}`,
                  borderRadius: 'var(--raio-lg)', padding: '16px 20px',
                  display: 'flex', alignItems: 'center', gap: '14px',
                  opacity: perfil.ativo ? 1 : 0.55, boxShadow: 'var(--sombra)',
                }}>
                  <div style={{
                    width: '44px', height: '44px', borderRadius: '50%',
                    background: ROLE_CORES[perfil.role] ?? 'var(--cor-principal)',
                    color: 'white', fontSize: '18px', fontWeight: '700',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                  }}>
                    {inicial}
                  </div>

                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: '600', display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {tituloPrincipal}
                      </span>
                      <BadgeRole role={perfil.role} />
                      {!perfil.ativo && <span style={{ fontSize: '11px', color: '#9CA3AF' }}>Inactivo</span>}
                    </div>
                    {perfil.nome && perfil.email && (
                      <div style={{ fontSize: '13px', color: 'var(--cor-texto-suave)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {perfil.email}
                      </div>
                    )}
                    {perfil.telefone && (
                      <div style={{ fontSize: '12px', color: 'var(--cor-texto-suave)' }}>
                        📞 {perfil.telefone}
                      </div>
                    )}
                  </div>

                  <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexShrink: 0 }}>
                    <button
                      onClick={() => { setEditando(editando === perfil.id ? null : perfil.id); setCriando(false); toast.erro(null) }}
                      className="btn-secundario"
                      style={{ padding: '5px 12px', fontSize: '12px' }}
                    >
                      {editando === perfil.id ? 'Cancelar' : 'Editar'}
                    </button>
                    <button
                      onClick={() => eliminar(perfil)}
                      style={{ background: 'none', border: '1px solid #FCA5A5', borderRadius: 'var(--raio)', padding: '5px 12px', cursor: 'pointer', fontSize: '12px', color: '#DC2626' }}
                    >
                      Eliminar
                    </button>
                  </div>
                </div>

                {editando === perfil.id && (
                  <FormEditarManager
                    perfil={perfil}
                    onSave={guardarEdicao}
                    onCancel={() => setEditando(null)}
                    guardando={guardando}
                  />
                )}
              </div>
            )
          })}

          {lista.length === 0 && !criando && (
            <p style={{ color: 'var(--cor-texto-suave)', textAlign: 'center', padding: '32px' }}>
              Sem managers registados.
            </p>
          )}
        </div>
      )}
    </div>
  )
}
